import { useQuery } from "@apollo/client";
import gqlFooter from "@assets/gql/footer.gql";
import React, { useEffect, useRef, useState } from "react";
import { Template } from "@assets/spa/template";
import { useLayoutContext } from "@assets/spa/context/layout";
import { useLang } from "@ambiguous/useLang";
export function Footer() {
    var _a;
    const [sections, setSections] = useState([]);
    const [layout, setLayout] = useLayoutContext();
    const footerIdRef = useRef(null);
    const footerCssRef = useRef(null);
    const [language] = useLang();
    const { data, loading } = useQuery(gqlFooter, {
        variables: {
            id: layout === null || layout === void 0 ? void 0 : layout.footerId,
            language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        },
        skip: !(layout === null || layout === void 0 ? void 0 : layout.footerId)
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!data)
            return;
        if (((_a = data.header) === null || _a === void 0 ? void 0 : _a.id) === null)
            return;
        setSections(JSON.parse(((_b = data === null || data === void 0 ? void 0 : data.footer) === null || _b === void 0 ? void 0 : _b.elementorData) || '[]'));
        setLayout({ footerId: (_c = data === null || data === void 0 ? void 0 : data.footer) === null || _c === void 0 ? void 0 : _c.id });
        footerIdRef.current = (_d = data === null || data === void 0 ? void 0 : data.footer) === null || _d === void 0 ? void 0 : _d.id;
        footerCssRef.current = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.footer) === null || _e === void 0 ? void 0 : _e.css) === null || _f === void 0 ? void 0 : _f.at(0)) === null || _g === void 0 ? void 0 : _g.href;
    }, [data]);
    if (loading)
        return React.createElement(React.Fragment, null);
    return (React.createElement("footer", null,
        React.createElement(Template, { sections: sections, postId: (_a = data === null || data === void 0 ? void 0 : data.footer) === null || _a === void 0 ? void 0 : _a.databaseId, css: footerCssRef.current, awaitCss: true })));
}
